import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class THeadCustom extends PureComponent {
  renderChild = () => {
    const { title = '--', subTitle = '--', children } = this.props;
    return (
      <>
        <span>{title}</span>
        {children}
        <small className="under-line small-text">{subTitle}</small>
      </>
    );
  };

  render() {
    const { isDropDown } = this.props;

    return isDropDown ? (
      <div className="fa-checkup-dropdown-search-box">
        <div className="dropdown drop-sort">{this.renderChild()}</div>
      </div>
    ) : (
      <div>{this.renderChild()}</div>
    );
  }
}

THeadCustom.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDropDown: PropTypes.bool,
};

THeadCustom.defaultProps = {
  title: '--',
  subTitle: '--',
  isDropDown: true,
};

export default THeadCustom;
